export var rawTransformation = function (value) { return value; };
